<template>
  <div id="previne-brasil-simulador">
    <div class="container">
      <div class="row">
        <!-- Step 1 -->
        <div class="col-lg-12 step-1" v-if="step == 1">
          <img
            src="@/assets/images/logo-previne-brasil.png"
            alt=""
            class="logo"
          />
          <h4>
            Bem vindo ao cofinanciamento federal, o novo financimento da APS
            2024+.
          </h4>
          <button class="button" role="button" @click="step = 2">
            Simulador
          </button>
        </div>

        <!-- Step 2 -->
        <div class="col-lg-12 step-2" v-if="step == 2">
          <h2>Cofinanciamento federal 2024+</h2>
          <div class="row">
            <div class="col-lg-6">
              <vue-select
                :options="estados"
                label="uf"
                placeholder="UF"
                @input="onChangeEstados"
                v-model="estado"
                class="vue-select-estado"
              >
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
            <div class="col-lg-6">
              <vue-select
                :options="municipios"
                label="nome"
                placeholder="Município"
                @input="onChangeEstados"
                v-model="municipio"
                class="vue-select-estado"
                :loading="loadingSelect"
              >
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
            <div class="col-lg-12">
              <button class="button" role="button" @click="step = 3">
                Avançar
              </button>
            </div>
          </div>
        </div>

        <!-- Step 3 -->
        <div class="col-lg-12 step-3" v-if="step == 3">
          <div>
            <button
              @click="converterParaAudio"
              :disabled="conversaoEmAndamento"
            >
              Play
            </button>
            <button @click="pausarConversao" :disabled="!conversaoEmAndamento">
              Pausar
            </button>
          </div>
          <div>
            <progress ref="progresso" max="100" :value="progresso"></progress>
          </div>
          <div class="words">
            <span
              v-for="(word, index) in palavras"
              :key="index"
              :style="{ color: word.cor }"
              >{{ word.texto }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      step: 3,
      estados: [
        { uf: 'AC' },
        { uf: 'AL' },
        { uf: 'AP' },
        { uf: 'AM' },
        { uf: 'BA' },
        { uf: 'CE' },
        { uf: 'DF' },
        { uf: 'ES' },
        { uf: 'GO' },
        { uf: 'MA' },
        { uf: 'MT' },
        { uf: 'MS' },
        { uf: 'MG' },
        { uf: 'PA' },
        { uf: 'PB' },
        { uf: 'PR' },
        { uf: 'PE' },
        { uf: 'PI' },
        { uf: 'RJ' },
        { uf: 'RN' },
        { uf: 'RS' },
        { uf: 'RO' },
        { uf: 'RR' },
        { uf: 'SC' },
        { uf: 'SP' },
        { uf: 'SE' },
        { uf: 'TO' },
      ],
      estado: '',
      municipios: [],
      municipio: '',
      loadingSelect: false,
      textoParaAudio: `Olá gestor do município de NOVA OLINDA PB.
Essa é uma simulação sobre o cofinanciamento federal da APS a partir de 2024.
Acompanhe quanto o seu município terá de aumento no repasse federal da APS por ano.

NOVA OLINDA - PB está na Faixa 2 de vulnerabilidade segundo o IPEA, na Faixa 1 do indicador de equidade, tem estimativa de cinco mil oitocentos e noventa e duas pessoas segundo o IBGE 2021, Faixa 1 até 20 mil habitantes de porte Populacional segundo o IBGE. Além disso, o município tem 3 eSF, não tem eAP de 30 horas, não tem eAP de 20 horas, tem 1 eMulti, recebe custeio de atendimento remoto para 1 eMulti.

No Programa Previne Brasil, que é o modelo atual de distribuição de recursos, NOVA OLINDA - PB recebe por ano: R$ 650.165,33 na capitação ponderada, R$ 115.283,49 de pagamento por desempenho, R$ R$ 35.057,40 de valor fixo percapta, R$ 72.000,00 no informatiza APS e não recebe Saúde na Hora. A estimativa de repasse anual é de R$ 872.506,22 no Previne Brasil.
`,
      palavrasFormat: [],
      palavras: [],
      reproduzindo: false,
      progresso: 0,
      audioContext: new (window.AudioContext || window.webkitAudioContext)(),
      conversaoEmAndamento: false,
      source: '',
      indexAtualizarProgresso: 0,
    }
  },
  mounted() {
    window.speechSynthesis.cancel()
  },
  methods: {
    async onChangeEstados(item) {
      try {
        this.loadingSelect = true
        const response = await axios.get(
          `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${item.uf}/municipios`
        )
        this.municipios = response.data
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingSelect = false
      }
    },

    async converterParaAudio() {
      try {
        this.conversaoEmAndamento = true
        this.reproduzindo = true

        await this.audioContext.resume() // Resumir o contexto de áudio (necessário para alguns navegadores)

        const synthesis = window.speechSynthesis
        const utterance = new SpeechSynthesisUtterance(this.textoParaAudio)
        utterance.lang = 'pt-BR'

        // Limpar o destaque de palavras antes de começar a falar
        this.palavras = this.textoParaAudio
          .split(/\s+/)
          .map((texto) => ({ texto, cor: 'black' }))

        let charIndex = 0

        //onboundary é acionado quando a expressão falada atinge o limite de uma palavra ou frase.
        utterance.onboundary = (event) => {
          const tipoPalavraAtual = event.name
          const palavraAtual = this.palavras[charIndex]

          console.log(palavraAtual.texto)

          // this.$set(this.palavras, charIndex, {
          //   texto: palavraAtual.texto,
          //   cor: 'black',
          // })
          charIndex++
          this.atualizarProgresso()
        }

        // onend é acionado quando o enunciado termina de ser falado.
        utterance.onend = () => {
          // Reset para a cor original após o término da fala
          this.palavras.forEach((palavra, index) => {
            this.$set(this.palavras, index, {
              texto: palavra.texto,
              cor: 'black',
            })
          })
        }

        const audioBuffer = await this.textoParaAudioParaBuffer(
          synthesis,
          utterance
        )

        this.conversaoEmAndamento = false
      } catch (error) {
        console.error('Erro ao converter para áudio:', error)

        this.conversaoEmAndamento = false
      }
    },

    async textoParaAudioParaBuffer(synthesis, utterance) {
      return new Promise((resolve) => {
        synthesis.speak(utterance)
      })
    },

    atualizarProgresso() {
      const startTime = this.audioContext.currentTime
      if (this.conversaoEmAndamento) {
        const diferenca = Math.abs(startTime - this.indexAtualizarProgresso)
        console.log('startTime', startTime)
        // console.log('diferenca', diferenca)
        // console.log('index', this.indexAtualizarProgresso)
        if (diferenca < this.indexAtualizarProgresso) {
          this.$set(this.palavras, this.indexAtualizarProgresso, {
            texto: this.palavras[this.indexAtualizarProgresso].texto,
            cor: 'red',
          })
        }
        this.indexAtualizarProgresso++
        let sizeBar = this.indexAtualizarProgresso / this.palavras.length
        console.log(sizeBar)
        this.progresso = (sizeBar * 100).toFixed(1)
        // const duration = this.palavras.length
        // // Calcular o progresso da barra
        // this.progresso = (currentTime / duration) * 100
        // // Atualizar destaque de palavras conforme o progresso do áudio
        // const charIndex = Math.floor(
        //   (this.palavras.length - 1) * (this.progresso / 100)
        // )
        // this.palavras.forEach((palavra, index) => {
        //   this.$set(this.palavras, index, {
        //     texto: palavra.texto,
        //     cor: index === charIndex ? 'red' : 'black', // Destacar a palavra atual
        //   })
        // })
      }
    },

    pausarConversao() {
      // console.clear()
      this.indexAtualizarProgresso = 0
      this.conversaoEmAndamento = false
      this.progresso = 0
      window.speechSynthesis.cancel()
    },
  },
}
</script>

<style lang="scss" scoped>
#previne-brasil-simulador {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100vh;

  .button {
    background-color: #fff;
    border: 2px solid #004e8a;
    border-radius: 30px;
    box-shadow: #004e8a 4px 4px 0 0;
    color: #004e8a;
    cursor: pointer;
    display: inline-block;
    font-weight: 600;
    font-size: 18px;
    padding: 0 18px;
    line-height: 50px;
    text-align: center;
    text-decoration: none;
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
    text-transform: uppercase;
    &:hover {
      background-color: #fff;
    }
    &:active {
      box-shadow: #004e8a 2px 2px 0 0;
      transform: translate(2px, 2px);
    }
    @media (min-width: 768px) {
      min-width: 200px;
      margin: 40px auto;
      display: block;
    }
  }

  .step-1 {
    .logo {
      margin: 0 auto;
      display: block;
    }
    h4 {
      text-align: center;
    }
  }

  .step-2 {
    h2 {
      margin-bottom: 25px;
    }
  }

  .step-3 {
    button {
      background-color: #4caf50;
      color: white;
      padding: 10px 20px;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-size: 16px;
      margin-right: 10px;
    }

    button:hover {
      background-color: #45a049;
    }

    progress {
      width: 100%;
      height: 10px;
      margin-top: 10px;
    }

    .words {
      padding: 20px;
      border: 1px solid #ccc;
    }
  }

  .highlighted {
    color: red;
    font-weight: bold;
  }
}
</style>

<style>
#previne-brasil-simulador .vue-select-estado .vs__dropdown-toggle {
  min-height: 50px;
}
</style>
